import { useEffect, useState } from "react";

// Reactive viewport check for the responsive/app-shell layouts. Defaults to the
// phone breakpoint (≤768px). SSR-safe (returns false when window is absent).
export function useIsMobile(query = "(max-width: 768px)") {
  const read = () => (typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia(query).matches : false);
  const [isMobile, setIsMobile] = useState(read);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    // addEventListener is the modern API; addListener is the Safari<14 fallback.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
